import { render, staticRenderFns } from "./ReceiptDetailComponent.vue?vue&type=template&id=28b945e6&scoped=true"
import script from "./ReceiptDetailComponent.vue?vue&type=script&lang=js"
export * from "./ReceiptDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDetailComponent.vue?vue&type=style&index=0&id=28b945e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b945e6",
  null
  
)

export default component.exports